import React from "react";
import styled from "styled-components";
import { ArrowDownIcon } from "../../../CommonUI/Icon/ArrowDownIcon";
import { CloseRedIcon } from "../../../CommonUI/Icon/CloseRedIcon";
import { ErrorIcon } from "../../../CommonUI/Icon/ErrorIcon";
import { BaseSequenceStrategy } from "../BaseSequenceStrategy";
import { FlowSequenceCompleteStrategy } from "../../../rule-engine-core/Flow/Structure/FlowSequenceCompleteStrategy";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

const FlowEndDiv = styled.div`
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    background: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const FlowEndLabelDiv = styled.div`
    background: ${UIStyleConstants.WHITE_COLOR};
    border: 1px solid ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};

    box-shadow: 0px 2px 4px -2px ${UIStyleConstants.GRAY_COLOR};
    border-radius: 27px;

    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 140%;

    color: ${UIStyleConstants.BLUE_COLOR};
    cursor: pointer;

    display: flex;
    align-items: center;

    padding: 3px 0;
    position: relative;

    transition: border 0.1s ease-in-out;
    justify-content: center;

    width: 79px;

    &:hover {
        border: 1px solid ${UIStyleConstants.BLUE_COLOR};
    }

    > img {
        margin-right: 3px;
    }
`;

const FlowEndInErrorDiv = styled.div`
    background: ${UIStyleConstants.WHITE_COLOR};
    border: 1px solid ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};

    box-shadow: 0px 2px 4px -2px ${UIStyleConstants.GRAY_COLOR};
    border-radius: 27px;

    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 140%;

    color: ${UIStyleConstants.RED_COLOR};
    cursor: pointer;

    display: flex;
    align-items: center;

    padding: 3px 0;

    transition: border 0.1s ease-in-out;
    justify-content: center;

    width: 116px;

    &:hover {
        border: 1px solid ${UIStyleConstants.RED_COLOR};
    }

    > img {
        margin-right: 3px;
    }
`;

const ErrorMesssgeIconButton = styled.div`
    position: absolute;
    left: calc(100% + 4px);
    top: 50%;
    transform: translateY(-50%);
    border-radius: 50%;
    border: 1px solid transparent;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    &:hover {
        border: 1px solid ${UIStyleConstants.RED_COLOR};
    }
`;

const FlowEndLineDiv = styled.div`
    width: 1px;
    height: 8px;
    background: ${UIStyleConstants.BLUE_COLOR};
    border-radius: 1px;
    margin: 4px 0;
`;

export class RenderSequenceStrategy extends BaseSequenceStrategy {
    render() {
        const { sequence } = this.props;

        if (!sequence.isNormal) return null;

        switch (sequence.strategy) {
            case FlowSequenceCompleteStrategy.RETURN_TO_CALLING_STEP:
                return (
                    <FlowEndDiv id={sequence.endStep.getOutcomeInstructions()[0]?.getElementId()}>
                        <FlowEndLineDiv />
                        <FlowEndLabelDiv
                            onClick={this.showStrategyDialog}
                            data-testid={`${sequence._id}_end_flow`}
                        >
                            Edit
                        </FlowEndLabelDiv>
                    </FlowEndDiv>
                );
            case FlowSequenceCompleteStrategy.END_FLOW:
                return (
                    <FlowEndDiv id={sequence.endStep.getOutcomeInstructions()[0]?.getElementId()}>
                        <FlowEndLineDiv />
                        <FlowEndLabelDiv
                            onClick={this.showStrategyDialog}
                            data-testid={`${sequence._id}_end_flow`}
                        >
                            <ArrowDownIcon />
                            End flow
                        </FlowEndLabelDiv>
                    </FlowEndDiv>
                );
            case FlowSequenceCompleteStrategy.END_FLOW_IN_ERROR:
                return (
                    <FlowEndDiv id={sequence.endStep.getOutcomeInstructions()[0]?.getElementId()}>
                        <FlowEndLineDiv />
                        <div style={{ position: "relative" }}>
                            <FlowEndInErrorDiv
                                onClick={this.showStrategyDialog}
                                data-testid={`${sequence._id}_error_flow`}
                            >
                                <CloseRedIcon />
                                End flow in error
                            </FlowEndInErrorDiv>
                            <ErrorMesssgeIconButton
                                onClick={this.showErrorMessageForSequenceStrategy}
                                data-testid={`${sequence._id}_error_flow_set_message`}
                            >
                                <ErrorIcon />
                            </ErrorMesssgeIconButton>
                        </div>
                    </FlowEndDiv>
                );

            default:
                return null;
        }
    }
}
